
import {
    FastmenuAction,
    FastmenuActionTypes,
    FastmenuState
} from "store/types/fastmenu";


const initialState = {
    loadFastmenu: false,
    fastmenuData: [],
}

const fastmenuReducer = (state = initialState, action: FastmenuAction): FastmenuState => {
    switch (action.type) {
        case FastmenuActionTypes.GET_FASTMENU_REQUEST:
            return {
                ...state,
                loadFastmenu: true
            }
        case FastmenuActionTypes.GET_FASTMENU_SUCCESS:
            return {
                ...state,
                fastmenuData: action.payload,
                loadFastmenu: false
            }
        case FastmenuActionTypes.GET_FASTMENU_ERROR:
            return {
                ...state,
                loadFastmenu: false
            }
        case FastmenuActionTypes.ADD_FAVORITE_FASTMENU_SUCCESS:
            return{
                ...state,
                fastmenuData:action.payload,
            }
        default:
            return state;
    }
}
export default fastmenuReducer